import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import allApi from "../../../../api/allApi";
import Loader from "../../common/Loader";
import eyeIcon from "../../../../assets/images/eye-close.svg";
import eyeCloseIcon from "../../../../assets/images/eye-close.svg";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useLocalization } from "../../localization/LocalizationContext";
import dayjs from "dayjs";

function WirelessSettings({ vlanData, setVlanData, networkId, setData }) {
  const navigate = useNavigate();
  const { localizationStrings } = useLocalization();
  const [refreshing, setRefreshing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showData, setShowData] = useState(false);
  const [showPopUp, setShowPopUp] = useState(true);
  const [formData, setFormData] = useState({
    ssid: "",
    broadcastStatus: "0",
    band: [],
    vlanId: "",
    bandSteeringSt: "0",
    fastRoamingSt: "0",
    clientIsolation: "0",
    AllowLocalUIAccess: "0",
    scheduleEnabled: "0",
    // support802_11k_v: "0",
    securityAuthentication: "",
    password: "",
    allowLocalUIAccess: "0",
  });
  const [schedule, setSchedule] = useState({
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  });
  const [ssidList, setSsidList] = useState([]);
  const [SSID, setSSID] = useState([]);
  const [wlanId, setWlanId] = useState("");
  const [showAddSsidForm, setShowAddSsidForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [vlanList, setVlanList] = useState([]);
  const [schedulesList, setSchedulesList] = useState([]);
  const [showScheduleForm, setShowScheduleForm] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [isCreatingNewSchedule, setIsCreatingNewSchedule] = useState(false);
  const [slotsBooked, setSlotsBooked] = useState(false);
  const [scheduleName, setScheduleName] = useState("");

  useEffect(() => {
    if (networkId) {
      fetchSsidList(networkId);
      fetchSchedules(networkId);
    } else {
      setLoading(false);
      setRefreshing(false);
    }
  }, [networkId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      if (name === "band") {
        if (value === "All") {
          setFormData({
            ...formData,
            band: checked ? ["2.4 GHz", "5 GHz"] : [],
          });
        } else {
          setFormData((prevData) => {
            const newBand = checked
              ? [...prevData.band, value].filter((v) => v !== "All")
              : prevData.band.filter((band) => band !== value);
            return {
              ...prevData,
              band: newBand,
            };
          });
        }
      } else {
        setFormData({
          ...formData,
          [name]: checked ? "1" : "0",
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  useEffect(() => {
    if (typeof setData === "function") {
      setData({ ...formData, schedule });
    }
  }, [formData, schedule, setData]);

  const handleScheduleChange = (day, index, field, value) => {
    const updatedSchedule = { ...schedule };
    const slots = [...(updatedSchedule[day] || [])];
    slots[index] = {
      ...slots[index],
      [field]: value ? (dayjs.isDayjs(value) ? value.format("HHmm") : value) : "",
    };
    updatedSchedule[day] = slots;
    setSchedule(updatedSchedule);
  };

  const fetchSsidList = async (networkId) => {
    try {
      setLoading(true);
      setRefreshing(true);
      const api = new allApi();
      const response = await api.getRequest(
        `api/wireless/configuration/getAllSsids?networkId=${networkId}`
      );
      if (response.status === "OK" && response.response) {
        setSSID(response.response);
      } else {
        setSSID([]);
      }
    } catch (error) {
      console.error("Failed to fetch SSID list", error.message);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const fetchSchedules = async (networkId) => {
    try {
      const api = new allApi();
      const response = await api.getRequest(
        `api/wireless/configuration/getAllSsidSchedule?networkId=${networkId}`
      );
      if (response.status === "OK") {
        setSchedules(response.response || []);
      }
    } catch (error) {
      console.error("Error fetching schedules:", error);
    }
  };

  const handleSubmit = async (e, actionType) => {
    e.preventDefault();
    try {
      let payload = {
        ssid: formData.ssid,
        broadcastStatus: formData.broadcastStatus,
        band: formData.band.join(", "),
        vlanId: formData.vlanId,
        bandSteeringSt: formData.bandSteeringSt,
        fastRoamingSt: formData.fastRoamingSt,
        clientIsolation: formData.clientIsolation,
        AllowLocalUIAccess: formData.AllowLocalUIAccess,
        // scheduleEnabled: formData.scheduleEnabled,
        // support802_11k_v: formData.support802_11k_v,
        securityAuthentication: formData.securityAuthentication,
      };
      setLoading(true);
      setRefreshing(true);
      const api = new allApi();
      const response = await api.postRequest(
        `api/wireless/configuration/addSsid?networkId=${networkId}`,
        "",
        payload
      );

      if (response.message) {
        setShowPopUp(false);
        setShowData(true);
        if (actionType === "saveAndConfigure") {
          navigate(`/wifi-settings`);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const removeTimeSlot = (day, index) => {
    const updatedSchedule = { ...schedule };
    updatedSchedule[day].splice(index, 1);
    setSchedule(updatedSchedule);
  };

  const addTimeSlot = (day) => {
    const updatedSchedule = { ...schedule };
    updatedSchedule[day].push({ startTime: "", endTime: "" });
    setSchedule(updatedSchedule);
  };

  return (
    <div>
      <div className="wifi-ssid">
        <div>
          <h4>{localizationStrings?.wirelessSettings}</h4>
          <p>{localizationStrings?.ssidWifiInfo}</p>
        </div>
        <div>
          <button
            type="button"
            className="btn btn-fill"
            onClick={() => setShowAddSsidForm(!showAddSsidForm)}
          >
            {showAddSsidForm
              ? localizationStrings?.cancel
              : localizationStrings?.addNewSSID}
          </button>
        </div>
      </div>

      <div className="accordion mt-4" id="accordionRearrange">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              SSID
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionRearrange"
          >
            <div className="accordion-body">
              <div className="inc-card-table">
                <table className="full-table m-head">
                  <thead>
                    <tr>
                      <th>SSID</th>
                      <th>{localizationStrings?.band}</th>
                      <th>{localizationStrings?.security}</th>
                      <th>{localizationStrings.broadcastStatus}</th>
                      <th>{localizationStrings?.fastRoaming}</th>
                      <th>{localizationStrings?.vlanId}</th>
                    </tr>
                  </thead>
                  {loading ? (
                    <Loader />
                  ) : SSID && SSID.length > 0 ? (
                    <tbody>
                      {SSID.map((wifi, index) => (
                        <tr key={index}>
                          <td>{wifi.ssid}</td>
                          <td>
                            <div className="band-pills">
                              {wifi?.band
                                .replace(/\s+/g, "")
                                .toUpperCase()
                                .includes("2.4GHZ") && (
                                <span className="yellow">2.4 GHz</span>
                              )}
                              {wifi?.band
                                .replace(/\s+/g, "")
                                .toUpperCase()
                                .includes("5GHZ") && (
                                <span className="blue">5 GHz</span>
                              )}
                            </div>
                          </td>
                          <td>{wifi.securityAuthentication || "N/A"}</td>
                          <td>
                            <span
                              className={
                                "d-status " +
                                (wifi.broadcastStatus === 1
                                  ? "online"
                                  : "offline")
                              }
                            >
                              {wifi.broadcastStatus === 1
                                ? "Enabled"
                                : "Disabled"}
                            </span>
                          </td>
                          <td>
                            <span
                              className={
                                "d-status " +
                                (wifi.fastRoamingSt === "1"
                                  ? "online"
                                  : "offline")
                              }
                            >
                              {wifi.fastRoamingSt === "1"
                                ? "Enabled"
                                : "Disabled"}
                            </span>
                          </td>
                          <td>{wifi.vlanId}</td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="7">
                          <div
                            style={{ textAlign: "center", fontSize: "medium" }}
                          >
                            {localizationStrings?.noData}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-line"></div>

      {showAddSsidForm && (
        <div className="modal-body">
          <form>
            <div className="add-ssid-body">
              <h4>{localizationStrings?.newWifiSettings}</h4>
              <div className="row d-flex">
                <div className="col-lg-6">
                  <input
                    type="text"
                    className="form-control"
                    name="ssid"
                    placeholder="SSID"
                    value={formData.ssid}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-6">
                  <div className="switch-box">
                    <strong>{localizationStrings?.broadcastSSID}</strong>
                    <label className="ice-switch">
                      <input
                        type="checkbox"
                        name="broadcastStatus"
                        checked={formData.broadcastStatus === "1"}
                        onChange={handleChange}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="border-line"></div>

              <h4 className="mt-3">{localizationStrings?.band}</h4>
              <p>{localizationStrings?.wpaInfo}</p>
              <div className="row">
                <div className="col-lg-3 checkbox-group">
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      name="band"
                      value="All"
                      checked={formData.band.length === 2}
                      onChange={handleChange}
                    />
                    <span className="indicator"></span>
                    <strong>{localizationStrings?.all}</strong>
                  </label>
                </div>
                <div className="col-lg-3 checkbox-group">
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      name="band"
                      value="2.4 GHz"
                      checked={formData.band.includes("2.4 GHz")}
                      onChange={handleChange}
                    />
                    <span className="indicator"></span>
                    <strong>2.4 GHz</strong>
                  </label>
                </div>
                <div className="col-lg-3 checkbox-group">
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      name="band"
                      value="5 GHz"
                      checked={formData.band.includes("5 GHz")}
                      onChange={handleChange}
                    />
                    <span className="indicator"></span>
                    <strong>5 GHz</strong>
                  </label>
                </div>
              </div>

              <div className="border-line"></div>

              <h4 className="mt-3">{localizationStrings?.securitySettings}</h4>
              <div className="row">
                <div className="col-lg-6">
                  <label htmlFor="security" className="col-form-label">
                    {localizationStrings?.security}
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    id="securityAuthentication"
                    className="form-select"
                    name="securityAuthentication"
                    placeholder="Select Security"
                    value={formData.securityAuthentication}
                    onChange={handleChange}
                  >
                    <option value="">
                      {localizationStrings?.selectSecurity}
                    </option>
                    <option value="WPA2 Personal">
                      {localizationStrings?.WPA2Personal}
                    </option>
                    <option value="WPA2 Personal Mixed">
                      {localizationStrings?.WPA2PersonalMixed}
                    </option>
                    <option value="WPA3 Personal">
                      {localizationStrings?.WPA3Personal}
                    </option>
                    <option value="WPA3 Personal Mixed">
                      {localizationStrings?.WPA3PersonalMixed}
                    </option>
                  </select>
                </div>
              </div>
              {formData.securityAuthentication === "WPA2 Personal" && (
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <div className="switch-box">
                      <strong>{localizationStrings?.multiPresharedKey}</strong>
                      <label className="ice-switch">
                        <input
                          type="checkbox"
                          name="multiPsK"
                          checked={formData.multiPsK}
                          onChange={() =>
                            setFormData((prev) => ({
                              ...prev,
                              multiPsK: !prev.multiPsK,
                            }))
                          }
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>

                  {formData.multiPsK && (
                    <div className="col-lg-6">
                      <label htmlFor="password" className="col-form-label">
                        {localizationStrings?.password}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="input-wrapper">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          name="password"
                          placeholder="Password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <img
                          src={showPassword ? eyeIcon : eyeCloseIcon}
                          alt={showPassword ? "Hide password" : "Show password"}
                          className="show-password"
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="border-line"></div>
              <h4 className="mt-3">{localizationStrings?.networkSettings}</h4>
              <div className="row mt-3">
                <div className="col-lg-12">
                  <div className="switch-box">
                    <strong>{localizationStrings?.clientIsolation}</strong>
                    <label className="ice-switch">
                      <input
                        type="checkbox"
                        name="clientIsolation"
                        checked={vlanData.clientIsolation === "1"}
                        onChange={(e) =>
                          setVlanData((prev) => ({
                            ...prev,
                            clientIsolation: e.target.checked ? "1" : "0",
                          }))
                        }
                      />{" "}
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="border-line"></div>
              <div className="row mt-3">
                <div className="col-lg-12">
                  <div className="switch-box">
                    <strong>{localizationStrings?.accessToLocalUI}</strong>
                    <label className="ice-switch">
                      <input
                        type="checkbox"
                        name="allowLocalUIAccess"
                        checked={formData.allowLocalUIAccess === "1"}
                        onChange={handleChange}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="border-line"></div>
              <h4 className="mt-3 mb-4">
                {localizationStrings?.radioSettings}
              </h4>
              <div className="row">
                <div className="col-lg-4">
                  <div className="switch-box">
                    <strong>{localizationStrings?.bandSteering}</strong>
                    <label className="ice-switch">
                      <input
                        type="checkbox"
                        name="bandSteeringSt"
                        checked={vlanData.bandSteeringSt === "1"}
                        onChange={(e) =>
                          setVlanData((prev) => ({
                            ...prev,
                            bandSteeringSt: e.target.checked ? "1" : "0",
                          }))
                        }
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="switch-box">
                    <strong>
                      {localizationStrings?.fastRoaming} (802.11r)
                    </strong>
                    <label className="ice-switch">
                      <input
                        type="checkbox"
                        name="fastRoamingSt"
                        checked={vlanData.fastRoamingSt === "1"}
                        onChange={(e) =>
                          setVlanData((prev) => ({
                            ...prev,
                            fastRoamingSt: e.target.checked ? "1" : "0",
                          }))
                        }
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="switch-box">
                    <strong>802.11k/v</strong>
                    <label className="ice-switch">
                      <input
                        type="checkbox"
                        name="kvrStatus"
                        checked={formData.kvrStatus === "1"}
                        onChange={handleChange}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="border-line"></div>
              <div className="row mt-3">
                <div className="col-lg-12">
                  <div className="switch-box">
                    <strong>{localizationStrings?.enableSSIDSchedule}</strong>
                    <label className="ice-switch">
                      <input
                        type="checkbox"
                        name="scheduleEnabled"
                        checked={formData.scheduleEnabled === "1"}
                        onChange={handleChange}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>
              </div>

              {formData.scheduleEnabled === "1" && (
                <div className="mt-3">
                  <div className="row">
                    <div className="col-lg-12">
                      <label htmlFor="vlanId" className="col-form-label">
                        {localizationStrings?.selectSchedule}
                      </label>
                      <select
                        className="form-select"
                        value={formData.schedule}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            schedule: e.target.value,
                          })
                        }
                      >
                        <option value="">
                          {localizationStrings?.selectSchedule}
                        </option>
                        {schedules.map((schedule) => (
                          <option
                            key={schedule.scheduleId}
                            value={schedule.scheduleName}
                          >
                            {schedule.scheduleName}
                          </option>
                        ))}
                      </select>
                      <br />
                      <p className="text-center mt-2">
                        {localizationStrings?.or}
                      </p>
                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <div className="switch-box">
                            <strong
                              onClick={() =>
                                setIsCreatingNewSchedule(!isCreatingNewSchedule)
                              }
                            >
                              {localizationStrings?.configureNewSchedule}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <br />

                      {showPopUp && (
                        <div>
                          {showScheduleForm && !slotsBooked ? (
                            <div>
                              <div className="schedule-week">
                                <h4>{localizationStrings?.scheduleName}</h4>
                                <div className="row d-flex">
                                  <div className="col-lg-6">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Schedule Name"
                                      value={scheduleName}
                                      onChange={(e) =>
                                        setScheduleName(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="border-line"></div>
                                <p>
                                  {localizationStrings?.locationTimezone} -
                                  Asia/Kolkata (IST)
                                </p>
                                <h4>{localizationStrings?.days}</h4>
                                <p>{localizationStrings?.slotSelectionInfo}</p>
                                <div className="schedule-slot-scroller">
                                  {Object.keys(schedule).map((day) => (
                                    <div className="schedule-days" key={day}>
                                      <div className="sc-day-title">
                                        <h4>{day}</h4>
                                        <div>
                                          <button
                                            className="icon-btn"
                                            onClick={() => addTimeSlot(day)}
                                          >
                                            <i
                                              className="fa fa-plus"
                                              aria-hidden="true"
                                            ></i>
                                          </button>
                                        </div>
                                      </div>
                                      <div className="schedule-time">
                                        {schedule[day].map((slot, index) => (
                                          <div
                                            className="schedule-time-box"
                                            key={index}
                                          >
                                            <div className="start-time">
                                              <h4>
                                                {localizationStrings?.startOn}
                                              </h4>
                                              <TimePicker
                                                value={
                                                  slot.startTime
                                                    ? dayjs.isDayjs(slot.startTime)
                                                      ? slot.startTime
                                                      : dayjs(slot.startTime, "HHmm")
                                                    : null
                                                }
                                                onChange={(value) =>
                                                  handleScheduleChange(
                                                    day,
                                                    index,
                                                    "startTime",
                                                    value
                                                  )
                                                }
                                                slotProps={{
                                                  textField: {
                                                    className: "time-picker-input",
                                                  },
                                                }}
                                                slots={{
                                                  openPickerIcon: () => (
                                                    <AccessTimeIcon fontSize="small" />
                                                  ),
                                                }}
                                              />
                                            </div>
                                            <div className="end-time">
                                              <h4>
                                                {localizationStrings?.endOn}
                                              </h4>
                                              <TimePicker
                                                value={
                                                  slot.endTime
                                                    ? dayjs.isDayjs(slot.endTime)
                                                      ? slot.endTime
                                                      : dayjs(slot.endTime, "HHmm")
                                                    : null
                                                }
                                                onChange={(value) =>
                                                  handleScheduleChange(
                                                    day,
                                                    index,
                                                    "endTime",
                                                    value
                                                  )
                                                }
                                                slotProps={{
                                                  textField: {
                                                    className: "time-picker-input",
                                                  },
                                                }}
                                                slots={{
                                                  openPickerIcon: () => (
                                                    <AccessTimeIcon fontSize="small" />
                                                  ),
                                                }}
                                              />
                                            </div>
                                            <button
                                              onClick={() =>
                                                removeTimeSlot(day, index)
                                              }
                                              className="delete-slot"
                                            >
                                              <i
                                                className="fa fa-trash"
                                                aria-hidden="true"
                                              ></i>
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="schedule-wrapper">
                              {schedulesList.length > 0 ? (
                                schedulesList.map((scheduleItem) => (
                                  <div
                                    className="schedule-item"
                                    key={scheduleItem.scheduleId}
                                  >
                                    <div className="schedule-detail">
                                      <h5>{scheduleItem.scheduleName}</h5>
                                      <p>
                                        Status:{" "}
                                        {scheduleItem.scheduleStatus === 1
                                          ? "Active"
                                          : "Inactive"}
                                      </p>
                                      <p>
                                        {localizationStrings?.createdAt}
                                        {":"}{" "}
                                        {new Date(
                                          scheduleItem.createdAt * 1000
                                        ).toLocaleString()}
                                      </p>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <p>{localizationStrings?.noData}</p>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
export default WirelessSettings;
